import { render, staticRenderFns } from "./faceVerifyCmp.vue?vue&type=template&id=c1807c26&scoped=true"
import script from "./faceVerifyCmp.vue?vue&type=script&lang=js"
export * from "./faceVerifyCmp.vue?vue&type=script&lang=js"
import style0 from "./faceVerifyCmp.vue?vue&type=style&index=0&id=c1807c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1807c26",
  null
  
)

export default component.exports